import { useUserGroups } from "../../hooks/authHooks";
import { useFeatureFlags } from "../../hooks/useFeatureFlags";

import { dashboardTiles } from "./Dashboard.constants";

export const useVisibleTiles = () => {
  const userGroups = useUserGroups();
  const flags = useFeatureFlags();
  const isGlobalAdmin = userGroups.includes("GlobalAdmin");
  return dashboardTiles.filter((tile) => {
    if (tile.featureFlag && !flags[tile.featureFlag]) return false;
    return (
      isGlobalAdmin ||
      ((tile.visible ?? true) &&
        (tile.allowedGroups.length === 0 || tile.allowedGroups.some((g) => userGroups.includes(g))))
    );
  });
};
